export const LOCATION_HOME = 'home';
export const LOCATION_DEALERSHIP = 'dealership';
export const LOCATION_OTHER = 'other';
